const startCallbacks = [];
const endCallbacks = [];

export function onStart(callback) {
  startCallbacks.push(callback);
}

export function onEnd(callback) {
  endCallbacks.push(callback);
}

export function refreshStart() {
  startCallbacks.forEach(callback => callback());
}

export function refreshEnd() {
  endCallbacks.forEach(callback => callback());
}
